import { useEffect, useState } from 'react';

/**
 *
 * @param key the query key
 * @returns the query value to the query key
 */
const useNextQueryParam = (key: string): string => {
  const [urlParam, setUrlParam] = useState<string>('');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const keyFromUrl = urlParams.get(key) || '';
    setUrlParam(keyFromUrl);
  }, [key, urlParam]);

  return urlParam;
};

export default useNextQueryParam;
